import NotificationApi from '@apis/notification/NotificationApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetNotificationsParams } from '@models/notification';

const notificationQueries = createQueryKeys('notifications', {
    list: (params: Omit<GetNotificationsParams, 'page'>) => ({
        queryKey: ['list', params],
    }),
    unread: () => ({
        queryKey: ['unread'],
        queryFn: () => NotificationApi.getHasUnread(),
    }),
});

export default notificationQueries;
